import { TablePagination } from '@mui/material'
import { UsageLogInfo } from 'api/usageLog'
import LoadingWrapper from 'components/LoadingWrapper'

import LogPaginatedTable from './LogPaginatedTable'

type Props = {
  logList: UsageLogInfo[] | null // null is loading
  total: number
  page: number
  perPage: number
  onPageChange: React.ComponentProps<typeof TablePagination>['onPageChange']
  onRowsPerPageChange: React.ComponentProps<typeof TablePagination>['onRowsPerPageChange']
}

function UsageLogList({ logList, total, page, perPage, onPageChange, onRowsPerPageChange }: Props) {
  const pageInvalid = page < 0 || page * perPage > total

  return (
    <LoadingWrapper loaded={Boolean(logList)}>
      <LogPaginatedTable
        rows={logList || []}
        page={pageInvalid ? 0 : page}
        totalCount={total}
        rowsPerPage={perPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </LoadingWrapper>
  )
}

export default UsageLogList
